import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

/**
 * Chip de pendiente: lo que una fila de lista tiene por resolver ("Atrasado 10
 * días", "App · 3 actualizaciones", "2 dudas de la IA"). 24px de alto, radio 7,
 * 11,5px/700 sobre el tono soft de su tipo, y es un botón: llevarte a donde se
 * resuelve es todo su trabajo. En hover suma un halo tenue de tinta.
 *
 * Es más grande que `Etiqueta` (que nombra un estado y no se toca) y menos que un
 * `Badge`. Tonos: `danger`, `info` y `warning`.
 */
const chipPendienteVariants = cva(
  "inline-flex h-6 items-center gap-[0.3125rem] rounded-[0.4375rem] px-2 text-[0.71875rem] font-bold whitespace-nowrap transition-shadow outline-none hover:shadow-[0_0_0_3px_rgba(23,24,27,0.06)] focus-visible:ring-ring/50 focus-visible:ring-[3px]",
  {
    variants: {
      tono: {
        danger: "bg-danger-soft text-danger-texto",
        info: "bg-info-soft text-info-soft-foreground",
        warning: "bg-warning-soft text-warning-texto",
      },
    },
    defaultVariants: { tono: "danger" },
  }
)

function ChipPendiente({
  tono,
  className,
  ...props
}: Omit<React.ComponentProps<"button">, "type"> & VariantProps<typeof chipPendienteVariants>) {
  return (
    <button
      type="button"
      data-slot="chip-pendiente"
      data-tono={tono}
      className={cn(chipPendienteVariants({ tono }), className)}
      {...props}
    />
  )
}

export { ChipPendiente }
